<template>
  <v-form @submit="onSubmit">
    <mapping-form :doc="doc" :categories="categories" :zones="zones" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import MappingForm from "./MappingForm";

export default {
  name: "UserServiceEdit",
  components: {
    MappingForm,
  },
  data() {
    return {};
  },
  props: {
    doc: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Array,
      default: () => [],
    },
    zones: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit("updateNote", this.doc);
    },
  },
};
</script>
